var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21411 3.21411V22.5H26.7855V3.21411H3.21411ZM24.6427 20.3572H5.35718V5.35718H24.643V20.3572H24.6427ZM4.28579 24.6427H25.7144V26.7855H4.28579V24.6427Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.8573H9.64277V19.2859H7.5V12.8573ZM11.7858 6.42871H13.9286V19.2859H11.7858V6.42871ZM20.3572 8.57148H22.5V19.2856H20.3572V8.57148ZM16.0714 15.0001H18.2142V19.2859H16.0714V15.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.a781541c015078502c35df29560044dc.svg";
export { ForwardRef as ReactComponent };